import AboutComp from '../components/aboutComp';

const About = () => {
    return <AboutComp />;
};

export default About;
